import React from "react";
import PropTypes from "prop-types";
import PopUpPanel from "../PopUpPanel/PopUpPanel";
import "./AssetDeleteModal.scss";

const AssetDeleteModal = ({
    assetName,
    usage,
    loading,
    deleting,
    errorMessage,
    onClose,
    onDelete,
}) => {
    const usageCount = usage?.usageCount || 0;
    const featureUsages = usage?.featureUsages || [];
    const isInUse = usage?.inUse === true;

    return (
        <PopUpPanel closePanelFunc={onClose} className="asset-delete-modal" showCloseBtn={!deleting}>
            <div className="form-holder co-popup-content asset-delete-modal__content">
                <h2>Delete Asset</h2>
                <p>
                    <strong>{assetName}</strong>
                </p>

                {loading && <p>Checking where this asset is used in the campaign...</p>}

                {!loading && errorMessage && (
                    <p className="asset-delete-modal__error">{errorMessage}</p>
                )}

                {!loading && !errorMessage && isInUse && (
                    <>
                        <p className="asset-delete-modal__warning">
                            {usageCount > 1
                                ? `This asset is used ${usageCount} times within this campaign, so it cannot be deleted.`
                                : 'This asset is currently used within this campaign, so it cannot be deleted.'}
                        </p>
                        <p>It is referenced in these features:</p>
                        <ul className="asset-delete-modal__usage-list">
                            {featureUsages.map((featureUsage) => (
                                <li key={featureUsage.featureId}>
                                    {featureUsage.featureLabel}
                                </li>
                            ))}
                        </ul>
                    </>
                )}

                {!loading && !errorMessage && !isInUse && (
                    <p>This asset is not in use. Delete it from the campaign asset library?</p>
                )}

                <div className="asset-delete-modal__actions">
                    <button className="standard-button" type="button" onClick={onClose} disabled={deleting}>
                        {isInUse || errorMessage ? 'Close' : 'Cancel'}
                    </button>
                    {!loading && !errorMessage && !isInUse && (
                        <button
                            className="standard-button asset-delete-modal__delete-btn"
                            type="button"
                            onClick={onDelete}
                            disabled={deleting}
                        >
                            {deleting ? 'Deleting...' : 'Delete Asset'}
                        </button>
                    )}
                </div>
            </div>
        </PopUpPanel>
    );
};

AssetDeleteModal.propTypes = {
    assetName: PropTypes.string.isRequired,
    usage: PropTypes.shape({
        usageCount: PropTypes.number,
        inUse: PropTypes.bool,
        featureUsages: PropTypes.arrayOf(PropTypes.shape({
            featureId: PropTypes.string,
            featureLabel: PropTypes.string,
            usageCount: PropTypes.number,
        })),
    }),
    loading: PropTypes.bool,
    deleting: PropTypes.bool,
    errorMessage: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

AssetDeleteModal.defaultProps = {
    usage: null,
    loading: false,
    deleting: false,
    errorMessage: '',
};

export default AssetDeleteModal;